import { Column } from 'primereact/column'
import { useRef, useState } from 'react'
import { CustomTable, stringFilterTemplate, ButtonOverlay, TableButton, CustomTableRef } from 'medere-ui-framework'
import { PrimeIcons } from 'primereact/api'
import { Button } from 'primereact/button'
import SupplierModal, { SupplierForm } from './SupplierModal'
import { DocumentType, PaymentCondition, PaymentMethod, SupplierTypeDTO, VatCustomerCategory } from '../../interface/interface'
import { MultiSelect } from 'primereact/multiselect'
import { useSupplierService } from '../../servicesHooks/Supplier/useSupplierService'

function Supplier() {
  const { getAllSuppliers } = useSupplierService();
  const gridRef = useRef<CustomTableRef>(null)

  const [isOpen, setIsOpen] = useState(false)
  const [supplier, setSupplier] = useState<SupplierForm | null>(null)
  const options = [{
    label: 'Activo',
    value: true
  }, {
    label: 'Inactivo',
    value: false
  }]

  const [selectedOptions, setSelectedOptions] = useState<boolean[]>([])

  function activeStatus(product: any) {
    return product.active ? 'Activo' : 'Inactivo'
  }

  async function editSupplier(e: any) {

    let supplierType: SupplierTypeDTO | null = null
    if (e.suppliertype != null) {
      supplierType = {
        suppliertype: e.suppliertype,
        description: e.suppliertypedesc,
        fulldescription: e.suppliertypedesc,
        code: '',
      }
    }

    let paymentMethod: PaymentMethod | null = null
    if (e.paymentmethod != null) {
      paymentMethod = {
        paymentMethod: e.paymentmethod,
        active: true,
        _order: 0,
        methodName: e.paymentmethoddesc,
        i18ncodes: [],
      }
    }

    let paymentCondition: PaymentCondition | null = null
    if (e.paymentcondition != null) {
      paymentCondition = {
        paymentcondition: e.paymentcondition,
        description: e.paymentconditiondesc,
        code: '',
      }
    }

    let condIva: VatCustomerCategory | null = null
    if (e.vatcategory != null) {
      condIva = {
        vatcustomercategory: e.vatcategory,
        categoryname: e.vatcategorydesc
      }
    }
    let documentType: DocumentType | null = null
    if (e.vatidtype != null) {
      documentType = {
        documentType: e.vatidtype,
        longName: e.vatidtypedesc,
        shortName: e.vatidtypedesc,
        externalCode: '',
      }
    }

    setSupplier({
      medereentity: e.medereentity,
      businessName: e.businessname,
      commercialName: e.commercialname,
      invoiceAddress: e.address,
      phone: e.phone,
      secondaryPhone: e.secondaryphone,
      email: e.email,
      postalCode: e.postalcode,
      active: e.active,
      credit: null,
      debit: null,
      condIva,
      documentType,
      fiscalDocument: e.vatid,
      exempt: false,
      daysForExpiration: e.daysforexpiration,
      accounting: null,
      observations: e.observations,
      exemptDate: null,
      paymentCondition,
      paymentMethod,
      subAccounting: null,
      city: {
        id: e.city,
        name: e.cityname,
        isExternalId: e.cityExternalId ?? false,
      },
      supplierType,
      earningWithHoldingConcept: { description: '', withholdingconcept: e.earningwithholdingconcept}
    })
    setIsOpen(true)
  }

  return (
    <>
      <div className='min-h-screen m-4 flex flex-column'>
        <h2 className='textBold text-2xl title'>Proveedores</h2>
        <Button
          type='button'
          className='buttonMain3 self-end'
          label='Crear'
          iconPos='right'
          icon={PrimeIcons.PLUS}
          onClick={() => setIsOpen(true)}
        />
        <CustomTable
          idTable='AllSuppliersTable'
          getItems={getAllSuppliers}
          params={{
            isActive: selectedOptions.length > 0 ? selectedOptions : options.map(e => e.value)
          }}
          showGridlines
          resizableColumns
          ref={gridRef}
          filterRow
          clearFiltersClassName='buttonClear'
        >
          <Column body={(e) => {
            const supplier = e
            return <ButtonOverlay buttonClassName='button-grey p-button-rounded'>
              <div className='flex flex-column'>
                {/* <TableButton label='Ver detalle' onClick={() => { }} className='text-left TableButtonStyle text-sm my-1 p-1' /> */}
                <TableButton label='Editar' onClick={() => editSupplier(supplier)} className='text-left TableButtonStyle text-sm my-1 p-1' />
                {/* <TableButton label='Movimientos' onClick={() => { }} className='text-left TableButtonStyle text-sm my-1 p-1' /> */}
                {/* <TableButton label='Cuentas' onClick={() => { }} className='text-left TableButtonStyle text-sm my-1 p-1' /> */}
                {/* <TableButton label='Deshabilitar' onClick={() => deleteSupplier(supplier)} className='text-left TableButtonStyle text-sm my-1 p-1' /> */}
              </div>
            </ButtonOverlay>
          }} />
          <Column field='businessname' className='column' header='Razon social' filter filterElement={stringFilterTemplate} />
          <Column field='vatidtypedesc' className='column' header='Tipo de Doc.' filter filterElement={stringFilterTemplate} />
          <Column field='vatid' className='column' header='Documento Fiscal' filter filterElement={stringFilterTemplate} />
          <Column field='phone' className='column' header='Teléfono' filter filterElement={stringFilterTemplate} />
          <Column field='email' className='column' header='Email' filter filterElement={stringFilterTemplate} />
          <Column field='active' header='Activo' body={activeStatus} filter filterElement={<MultiSelect
            options={options}
            optionLabel='label'
            value={selectedOptions}
            onChange={(e) => setSelectedOptions(e.value)}
            className='text-info-slate'
          />} />
        </CustomTable>
      </div>
      {isOpen && <SupplierModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        refreshTable={gridRef.current?.refreshTable}
        supplier={supplier}
        setSupplier={setSupplier}
      />}
    </>
  )
}

export default Supplier
